export const getOrderConfig = (orderType: OrderType) => {
  const config = ORDER_CONFIG[orderType]
  return `orderBy: ${config.field}, orderDirection: ${config.direction}`
}


export enum OrderType {
  DEFAULT = "tokenId",
}

export enum OrderDirection {
  ASC = "asc",
  DESC = "desc"
}

export interface IOrderConfig {
  name: string;
  field: string;
  direction: OrderDirection;
}

export type IOrderConfigCollection = {
  [index in OrderType]: IOrderConfig;
};

export const ORDER_CONFIG: IOrderConfigCollection = {
  [OrderType.DEFAULT]: {field: "id", direction: OrderDirection.ASC, name: "id ASC"},
};
